import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)} 0`,
    height: '44px',
  },

  actionContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  draggable: {
    mx: theme.spacing(2),
    background: theme.palette.common.white,
    boxShadow:
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px rgb(0 0 0 / 14%), 0px 1px 5px rgb(0 0 0 / 12%)',
    borderRadius: '4px',
  },
})
